import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VContainer,
    { attrs: { fluid: "" } },
    [
      _vm.tplToWork.length
        ? _c(
            VRow,
            [
              _c(
                VCol,
                [
                  !_vm.tplToWork[0]
                    ? [
                        _c("p", { staticClass: "text-center" }, [
                          _vm._v(
                            "No hay data para mostrar. Por favor, verifique que el archivo cargado es correcto."
                          ),
                        ]),
                      ]
                    : _vm._l(_vm.tplToWork, function (tabla, index) {
                        return _c(
                          "div",
                          { key: tabla.name },
                          [
                            _c("h6", [
                              _vm._v(
                                _vm._s(_vm.capitalize(_vm.project[index]))
                              ),
                            ]),
                            _c("h6", [
                              _vm._v(
                                _vm._s(_vm.capitalize(_vm.dataset[index]))
                              ),
                            ]),
                            _c("h6", [
                              _vm._v(_vm._s(_vm.capitalize(_vm.table[index]))),
                            ]),
                            _c(
                              "h6",
                              { staticClass: "d-flex align-center" },
                              [
                                _c(
                                  VChip,
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      small: "",
                                      color: _vm.isRecordOk(tabla)
                                        ? "green"
                                        : "red",
                                      dark: "",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.isRecordOk(tabla) ? "OK" : "Error"
                                      )
                                    ),
                                  ]
                                ),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.tableMessage[index])),
                                ]),
                              ],
                              1
                            ),
                            tabla.columns && tabla.columns.length
                              ? [
                                  _c(
                                    "small",
                                    {
                                      staticStyle: {
                                        display: "block",
                                        "margin-bottom": "8px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.countsText(tabla.columns))
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "max-height": "420px",
                                        overflow: "auto",
                                      },
                                    },
                                    [
                                      _c(VDataTable, {
                                        staticClass: "elevation-1",
                                        attrs: {
                                          items: _vm.normalizeColumns(
                                            tabla.columns
                                          ),
                                          headers: _vm.headers,
                                          "disable-pagination": "",
                                          "hide-default-footer": "",
                                          "item-key": "name",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "item.success",
                                              fn: function (ref) {
                                                var item = ref.item
                                                return [
                                                  _c(
                                                    VChip,
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        color: item.success
                                                          ? "green"
                                                          : "red",
                                                        dark: "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.success
                                                            ? "OK"
                                                            : "Error"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "item.message",
                                              fn: function (ref) {
                                                var item = ref.item
                                                return [
                                                  item.message &&
                                                  item.message.length <= 80
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(item.message)
                                                        ),
                                                      ])
                                                    : item.message
                                                    ? _c(
                                                        VTooltip,
                                                        {
                                                          attrs: { bottom: "" },
                                                          scopedSlots: _vm._u(
                                                            [
                                                              {
                                                                key: "activator",
                                                                fn: function (
                                                                  ref
                                                                ) {
                                                                  var on =
                                                                    ref.on
                                                                  var attrs =
                                                                    ref.attrs
                                                                  return [
                                                                    _c(
                                                                      "span",
                                                                      _vm._g(
                                                                        _vm._b(
                                                                          {},
                                                                          "span",
                                                                          attrs,
                                                                          false
                                                                        ),
                                                                        on
                                                                      ),
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.message.slice(
                                                                              0,
                                                                              80
                                                                            ) +
                                                                              "…"
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                },
                                                              },
                                                            ],
                                                            null,
                                                            true
                                                          ),
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.message
                                                              )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _c("span", [_vm._v("—")]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                            _c("br"),
                          ],
                          2
                        )
                      }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.tableauRecords && _vm.tableauRecords.length > 0
        ? _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c(VDataTable, {
                    staticClass: "text-center table-inca",
                    attrs: {
                      responsive: "",
                      hover: "",
                      items: _vm.tableauRecords,
                      headers: [
                        { value: "id", text: "Name" },
                        {
                          value: "success",
                          text: "Status",
                          class: "text-center",
                        },
                        { value: "message", text: "Reason" },
                      ],
                      "disable-pagination": "",
                      "hide-default-footer": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.success",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                VChip,
                                {
                                  attrs: {
                                    small: "",
                                    color: item.success ? "green" : "red",
                                    dark: "",
                                  },
                                },
                                [_vm._v(_vm._s(item.success ? "OK" : "ERROR"))]
                              ),
                            ]
                          },
                        },
                        {
                          key: "item.message",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("span", [_vm._v(_vm._s(item.message || "—"))]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3174002150
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }